import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import TesterPreviewBanner from "./TesterPreviewBanner";
import { useAuth } from "../contexts/AuthContext";

// Tester preview = read-only vizuális előnézet a Dashboard kártyazárási
// logikájához. Preview módban CSAK a Dashboard érhető el (a többi route
// — Tudástár, Identitás, Aktív alap, agentek — redirect-elve van a
// Dashboard-ra), így admin valódi adatai NEM jelennek meg, és NEM lehet
// véletlenül módosítani sem őket. Teljes user-flow teszteléshez külön
// demo tester account szükséges (lásd memory/test_credentials.md).
const PREVIEW_ALLOWED_PATHS = new Set(["/dashboard"]);

export default function Layout() {
  const { user, loading, previewAsTester } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-3 text-[#a1a1a1] text-sm">
          <div className="w-2 h-2 rounded-full bg-[#5e50f7] animate-pulse" />
          Betöltés...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Preview-readonly guard: a preview módban a route-ok közül CSAK a
  // Dashboard érhető el. Minden más redirect-elve a Dashboard-ra (a banner
  // „Vissza admin nézetbe" gombbal kiléphet a preview-ból).
  if (previewAsTester && !PREVIEW_ALLOWED_PATHS.has(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex min-h-screen" style={{ background: "#121217" }}>
      <Sidebar />
      <main className="flex-1 min-w-0">
        <MobileNav />
        <TesterPreviewBanner />
        <Outlet />
      </main>
    </div>
  );
}
